import classNames from 'classnames'
import { DetailedHTMLProps, InputHTMLAttributes, forwardRef } from 'react'

import styles from './input.module.css'

interface IInputProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string
  description?: string
}

export const Input = forwardRef<HTMLInputElement, IInputProps>(({ label, description, className, ...props }, ref) => {
  const inputClass = classNames(styles.input, className)

  return (
    <div className="flex flex-col gap-1">
      {label && <label className={styles.label}>{label}</label>}
      <input className={inputClass} ref={ref} {...props} />
      {description && <span className={styles.description}>{description}</span>}
    </div>
  )
})

Input.displayName = 'InputComponent'
